import { INBOX_TYPES } from './inbox';
import {
  MESSAGE_TYPES,
  ORIENTATION,
} from 'dashboard/components-next/message/constants';

// Inbox types that show the sender name on left-aligned (peer) messages.
export const SENDER_LABEL_INBOX_TYPES = [INBOX_TYPES.INTERNAL];

export function shouldShowSenderLabel({
  channelType,
  orientation,
  groupWithPrevious = false,
  isPrivate = false,
  messageType,
  senderName,
}) {
  if (!SENDER_LABEL_INBOX_TYPES.includes(channelType)) return false;
  if (orientation !== ORIENTATION.LEFT) return false;
  if (groupWithPrevious) return false;
  if (isPrivate) return false;
  if (messageType === MESSAGE_TYPES.ACTIVITY) return false;

  return Boolean(senderName?.trim());
}
